import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDateWithLocale } from '../shared/utils';

/**
 * Modal to pick a day to swap with the current day. Excludes the current day from the list.
 */
export default function SwapDaysModal({ show, onHide, days = [], currentDayId, onConfirm }) {
  const { t } = useTranslation();
  const [selectedDayId, setSelectedDayId] = useState(null);

  useEffect(() => {
    if (!show) setSelectedDayId(null);
  }, [show]);

  const otherDays = days.filter((d) => d.id !== currentDayId);

  const handleConfirm = () => {
    if (selectedDayId && onConfirm) {
      onConfirm(currentDayId, selectedDayId);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('planDetail.days.swapDays.title', { defaultValue: 'Swap days' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          {t('planDetail.days.swapDays.pickDay', { defaultValue: 'Pick a day to swap with this one. Day plans and activities will be swapped while keeping dates in place.' })}
        </p>
        <ListGroup>
          {otherDays.map((day, index) => {
            const dayNumber = days.findIndex((d) => d.id === day.id) + 1;
            const isSelected = selectedDayId === day.id;
            return (
              <ListGroup.Item
                key={day.id}
                action
                active={isSelected}
                onClick={() => setSelectedDayId(day.id)}
                style={{ cursor: 'pointer' }}
              >
                {t('planDetail.days.day', { defaultValue: 'Day' })} {dayNumber}: {day.date ? formatDateWithLocale(day.date, 'EEE, MMM d') : ''}
                {day.activities?.length > 0 && (
                  <span className="text-muted small ms-2">
                    ({day.activities.length} {day.activities.length === 1 ? t('planDetail.overview.activity', { defaultValue: 'activity' }) : t('planDetail.overview.activities', { defaultValue: 'activities' })})
                  </span>
                )}
              </ListGroup.Item>
            );
          })}
        </ListGroup>
        {otherDays.length === 0 && (
          <p className="text-muted mb-0 mt-2">{t('planDetail.days.swapDays.noOtherDays', { defaultValue: 'No other days to swap with.' })}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('common.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button variant="primary" onClick={handleConfirm} disabled={!selectedDayId || otherDays.length === 0}>
          {t('planDetail.days.swapDays.confirm', { defaultValue: 'Swap days' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
